module.exports = __webpack_public_path__ + "img/LOGO_Blue-Black.ad551397.png";